module.exports = __webpack_public_path__ + "img/62.826c26ad.jpg";